import { DatePicker, Form } from "antd";
import React, { useState } from "react";

const SubjectDOB: React.FC = () => {
  return (
    <Form.Item
      name="dob"
      label="Dob"
      rules={[
        {
          required: true,
          message: "Please select the date of birth",
        },
      ]}
    >
      <DatePicker
        style={{ width: "100%" }}
        allowClear={false}
        format={"DD-MMM-YYYY"}
      />
    </Form.Item>
  );
};

export default SubjectDOB;
